import React from 'react'
import { Link } from 'react-router-dom'
import { Error } from '@mui/icons-material'

const StudentUnauthorized = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#f0f4f8',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      <div
        style={{
          textAlign: 'center',
          backgroundColor: '#fff',
          padding: '40px 50px',
          borderRadius: '10px',
          boxShadow: '0 15px 40px rgba(0, 0, 0, 0.1)',
          width: '100%',
          maxWidth: '600px',
          transform: 'translateY(0)',
          animation: 'fadeInUp 0.8s ease-out',
        }}
      >
        <Error
          style={{
            fontSize: '50px',
            color: '#e74c3c',
            marginBottom: '20px',
          }}
        />
        <h4
          style={{
            color: '#E74C3C',
            fontSize: '28px',
            marginBottom: '20px',
            fontWeight: '600',
          }}
        >
          Access Denied
        </h4>
        <p
          style={{
            fontSize: '16px',
            color: '#7f8c8d',
            marginBottom: '30px',
          }}
        >
          Sorry, it seems you don't have the necessary permissions to access this page. You must login with valid <b>Student credentials</b>
        </p>
        <div>
          <Link
            to='/login'
            style={{
              display: 'inline-block',
              textDecoration: 'none',
              backgroundColor: '#2ecc71',
              color: '#fff',
              padding: '5px 20px',
              borderRadius: '50px',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 10px rgba(46, 204, 113, 0.3)',
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = '#27ae60')}
            onMouseOut={(e) => (e.target.style.backgroundColor = '#2ecc71')}
          >
            Login
          </Link>
        </div>
        <div>
          <Link
            to='/'
            style={{
              display: 'inline-block',
              textDecoration: 'none',
              backgroundColor: '#3498db',
              color: '#fff',
              padding: '5px 20px',
              borderRadius: '50px',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              transition: 'all 0.3s ease',
              marginTop: '15px',
              boxShadow: '0 4px 10px rgba(52, 152, 219, 0.3)',
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = '#2980b9')}
            onMouseOut={(e) => (e.target.style.backgroundColor = '#3498db')}
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  )
}

export default StudentUnauthorized
